import React from "react";

import { formatNumber } from "helpers/getNumberFormats";
import { useColumnsHooks } from "./hooks/useColumnsHooks";
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";
import { ModalV2 } from "components/Modal/ModalV2";
import { FormEndownmentsAccount } from "./FormEndownmentsAccount";
import { DelCauses } from "./DelCauses";
import { UpdateNoteAccount } from "./UpdateNoteAccount";
import { ReassignFolioModal } from "./ReassignFolioModal";

export const columns_f = [
  {
    Header: "#",
    accessor: "position",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.position ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
  },
  {
    Header: "Folio",
    accessor: "folio",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.folio ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
  },
  {
    Header: "# Codigo",
    accessor: "accountCode",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.accountCode ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
  },
  {
    Header: "#Nombre",
    accessor: "accountName",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.accountName ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
  },
  {
    Header: "Producto",
    accessor: "name",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.name ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
    Cell: ({ original }) => {
      const { handleProductColumn } = useColumnsHooks({ original });
      return handleProductColumn;
    },
  },
  {
    Header: "Tipo de Nota",
    accessor: "type",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.type ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
    Cell: ({ original }) => {
      const { handleTypeColumn } = useColumnsHooks({ original });
      return handleTypeColumn;
    },
  },
  {
    Header: "Tipo de Pago",
    accessor: "methodPayment",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.methodPayment ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
    Cell: ({ original }) => {
      const { handleTypeColumn } = useColumnsHooks({
        original,
        key: "methodPayment",
      });
      return handleTypeColumn;
    },
  },
  {
    Header: "Bonificación",
    accessor: "gasBonus",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.gasBonus ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
  },
  {
    Header: "Cantidad",
    accessor: "quantity",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.quantity ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
    Cell: ({ original }) => {
      const { handleQuantityColumn } = useColumnsHooks({ original });
      return handleQuantityColumn;
    },
  },
  {
    Header: "Descuento",
    accessor: "discount",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.discount ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
    Cell: ({ original }) => <div>$ {formatNumber(original?.discount)}</div>,
  },
  {
    Header: "P.U",
    accessor: "price",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.price ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
    Cell: ({ original }) => {
      const pu = original?.details[0]?.price;
      return <div>$ {formatNumber(pu)}</div>;
    },
  },
  {
    Header: "Importe",
    accessor: "total",
    filterable: true,
    filterMethod: ({ value }, row) => {
      return String(row?.total ?? "")
        .toLowerCase()
        .includes(String(value).toLowerCase());
    },
    Cell: ({ original }) => <div>$ {formatNumber(original?.total)}</div>,
  },

  {
    Header: "Acciones",
    Cell: ({ original }) => {
      const {
        notesActionsButtons,
        open,
        openDel,
        openUpdate,
        openReassign,
        setOpen,
        setOpenDel,
        setOpenUpdate,
        setOpenReassign,
        isLoadingComp,
      } = useColumnsHooks({ original });
      return (
        <>
          <ActionsButtons buttons={notesActionsButtons} />
          <ModalV2 open={open} onClose={setOpen} title="Notas " toRight>
            <FormEndownmentsAccount editNote close={setOpen} note={original} />
          </ModalV2>
          <ModalV2
            open={openDel}
            onClose={setOpenDel}
            title="Seguro que desea eliminar la Nota?"
            justConfirm
          >
            <DelCauses note={original} onClose={setOpenDel} />
          </ModalV2>
          <ModalV2
            open={openUpdate}
            onClose={isLoadingComp?.updateNoteAcc ? () => {} : setOpenUpdate}
            title="¿Desea actualizar la Nota?"
            justConfirm
          >
            <UpdateNoteAccount onClose={setOpenUpdate} note={original} />
          </ModalV2>
          {openReassign && (
            <ReassignFolioModal open={openReassign} onClose={setOpenReassign} note={original} />
          )}
        </>
      );
    },
  },
];

export const columns_account = [
  {
    Header: "Producto",
    accessor: "name",
  },
  {
    Header: "Cantidad",
    accessor: "quantity",
  },
  {
    Header: "PU",
    accessor: "price",
  },
  {
    Header: "Total",
    accessor: "amount",
  },
];

export const columnsAccountCreate = (values, setValues) => {
  return [
    {
      Header: "Producto",
      accessor: "name",
    },
    {
      Header: "Cantidad",
      accessor: "quantity",
    },
    {
      Header: "PU",
      accessor: "price",
      Cell: ({ original }) => <div>$ {formatNumber(original?.price)}</div>,
    },
    {
      Header: "Descuento",
      Cell: ({ original }) => <div>$ {original?.discount?.toFixed(2)}</div>,
    },
    {
      Header: "Total",
      Cell: ({ original }) => {
        return <div>$ {formatNumber(original?.amount)}</div>;
      },
    },
    {
      Header: "Acciones",
      Cell: ({ original }) => {
        const { noteActionsButtons, blockBtn } = useColumnsHooks({
          original,
          values,
          setValues,
        });
        return blockBtn ? (
          <ActionsButtons buttons={noteActionsButtons} />
        ) : null;
      },
    },
  ];
};
